import {FETCH_AMBASSADORS, FETCH_AMBASSADORS_FAIL} from "./actionTypes";

const initialState = {
    ambassadors: [],
    status:0,
    message:""
}

const ambassadorsReducer = (state = initialState, action) => {
    switch (action.type){
        case FETCH_AMBASSADORS:
            return {
                ...state,
                ambassadors : action.payload.ambassadors,
                status : action.payload.status,
                message: action.payload.message
            }

        case FETCH_AMBASSADORS_FAIL:
            return{
                ...state,
                status : action.payload.status,
                message: action.payload.message
            }
        default:
            return {
                ...state
            }
    }
}
export default ambassadorsReducer;